export const PRIVACY_POLICY_URL = 'https://consciousbook.club/privacy';
export const TERMS_OF_USE_URL = 'https://consciousbook.club/terms';
export const SUPPORT_EMAIL = 'support@consciousbook.club';
export const SUPPORT_MAILTO = `mailto:${SUPPORT_EMAIL}`;

/** Bump when Terms of Use change in a way that requires re-acceptance (Apple 1.2). */
export const TERMS_VERSION = '2026-07-21';

export const hasAcceptedCurrentTerms = (settings) =>
  Boolean(settings?.termsAcceptedAt) && settings?.termsVersion === TERMS_VERSION;

export const buildTermsAcceptanceSettings = () => ({
  termsAcceptedAt: new Date().toISOString(),
  termsVersion: TERMS_VERSION,
});
